import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Header } from '../../../components';
import InviteCodesList from './InviteCodesList';

class InviteCodesPage extends Component {
  render() {
    return (
      <div className="hub-wrapperContainer">
        <div className="hub-headerContentWrapper">
          <Header />
          <div className="hub-contentWrapper" style={{ position: 'relative' }}>
            <InviteCodesList />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { auth } = state;
  return { auth };
};

export default connect(mapStateToProps, {})(InviteCodesPage);
